import { render, staticRenderFns } from "./Setion2.vue?vue&type=template&id=a9fbc638&scoped=true"
import script from "./Setion2.vue?vue&type=script&lang=js"
export * from "./Setion2.vue?vue&type=script&lang=js"
import style0 from "./Setion2.vue?vue&type=style&index=0&id=a9fbc638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fbc638",
  null
  
)

export default component.exports